module.exports = __webpack_public_path__ + "img/500.af9e3a2e.png";